<template>
	<div class="topbar">
		<div class="section-logo">
			<router-link :to="{ name: 'Dashboard' }">
				<img src="@/assets/RediR_white.png">
			</router-link>
		</div>
		<div
			v-if="isAuthenticated"
			class="header-items"
		>
			<router-link :to="{ name: 'Invite' }">
				<AppButton
					size="flex"
					color="none"
					item="icon"
				>
					<img
						src="@/assets/add_user.png"
						alt="add user"
					>
					Invite a friend
				</AppButton>
			</router-link>
			<div
				class="item"
				@click="userToggled = !userToggled"
			>
				<div class="user">
					<img
						src="@/assets/user.svg"
						alt="user"
					>
				</div>
				<img
					src="@/assets/arrow_down.png"
					alt="arrow"
				>
				<div
					v-show="userToggled"
					class="hover-options"
				>
					<router-link
						:to="{ name: 'Account' }"
						class="text"
					>
						Account settings
					</router-link>
					<router-link
						:to="{ name: 'Logout' }"
						class="text"
					>
						Log out
					</router-link>
				</div>
			</div>
		</div>
		<router-link
			v-else
			:to="{ name: 'Landing' }"
		>
			<AppButton
				color="primary"
				size="flex"
			>
				Signup
			</AppButton>
		</router-link>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'TheTopbar',

	data() {
		return {
			userToggled: false,
		};
	},

	computed: {
		...mapGetters('auth', [
			'isAuthenticated',
			'authStatus',
		]),
	},
};
</script>

<style lang="scss" scoped>
.topbar {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: $gap-2 $gap-5;
	margin-bottom: $gap-1;
	margin-left: auto;
	margin-right: auto;
	width: 100%;
	max-width: 1600px;
	box-sizing: border-box;

	.header-items {
		display: flex;
		align-items: center;

		.item {
			display: flex;
			position: relative;
			align-items: center;
			margin-left: $gap-4;
			padding: $gap-05;
			cursor: pointer;

			.section-description {
				margin-left: $gap-1;
				font-weight: $fontWeight-medium;
				color: $color-accent-300;
			}

			.hover-options {
				display: flex;
				flex-direction: column;
				position: absolute;
				top: 50px;
				right: 0;
				width: 284px;
				flex-wrap: wrap;
				padding: $gap-1 $gap-3;
				background-color: $color-accent-500;
				border-radius: 8px;
				z-index: 50;

				.text {
					padding: $gap-1 0;
					font-weight: $fontWeight-light;
					cursor: pointer;
					color: $color-accent-200;

					&:hover {
						color: $color-white;
					}
				}
			}

			.user {
				border-radius: 50%;
				width: 40px;
				height: 40px;
				overflow: hidden;
				border: 1px solid $color-accent-400;
				margin-right: $gap-1;

				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}
		}
	}
}
</style>
